import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BonusEvent } from '~models/bonus.model';
import { CrudService } from '~services/crud.service';
import { BonusApiService } from '~services/api/bonus.api.service';
import { filter, take } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'sa-bonus-event-archived',
  templateUrl: './bonus-event-archived.component.html',
  styleUrls: ['./bonus-event-archived.component.scss'],
})
export class BonusEventArchivedComponent implements OnInit {
  displayedColumns: string[] = [
    'name',
    'pricingType',
    'pricingValue',
    'startAt',
    'endAt',
    'loadCount',
    'totalBonusAmount',
    'quota',
    'createdAt',
    'deletedAt',
  ];
  dataSource: MatTableDataSource<BonusEvent> = new MatTableDataSource();

  constructor(private crud: CrudService, private bonusApiService: BonusApiService, public router: Router) {}

  ngOnInit(): void {
    this.crud.httpClientReady.pipe(filter(Boolean), take(1)).subscribe(() => {
      this.getArchivedBonusEvents();
    });
  }

  getArchivedBonusEvents() {
    this.bonusApiService.getArchivedBonusEvents().subscribe((items) => {
      this.dataSource = new MatTableDataSource(items);
    });
  }

  sortTable(event) {
    switch (event.active) {
      case 'id':
        const sortedId = this.dataSource.data.sort((a, b) => {
          return a.id.toString().localeCompare(b.id.toString());
        });
        if (event.direction === 'desc') {
          sortedId.reverse();
        }
        this.dataSource.data = sortedId;
        break;
      case 'name':
        const sortedName = this.dataSource.data.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        if (event.direction === 'desc') {
          sortedName.reverse();
        }
        this.dataSource.data = sortedName;
        break;
      case 'quota':
        const sortedQuota = this.dataSource.data.sort((a, b) => {
          return a.quota.toString().localeCompare(b.quota.toString());
        });
        if (event.direction === 'desc') {
          sortedQuota.reverse();
        }
        this.dataSource.data = sortedQuota;
        break;
      case 'startAt':
        const sortedStartAt = this.dataSource.data.sort((a, b) => {
          return a.startAt.localeCompare(b.startAt);
        });
        if (event.direction === 'desc') {
          sortedStartAt.reverse();
        }
        this.dataSource.data = sortedStartAt;
        break;
      case 'endAt':
        const sortedEndAt = this.dataSource.data.sort((a, b) => {
          return a.endAt.localeCompare(b.endAt);
        });
        if (event.direction === 'desc') {
          sortedEndAt.reverse();
        }
        this.dataSource.data = sortedEndAt;
        break;
      case 'createdAt':
        const sortedCreatedAt = this.dataSource.data.sort((a, b) => {
          return a.createdAt.localeCompare(b.createdAt);
        });
        if (event.direction === 'desc') {
          sortedCreatedAt.reverse();
        }
        this.dataSource.data = sortedCreatedAt;
        break;
      case 'deletedAt':
        const sortedDeletedAt = this.dataSource.data.sort((a, b) => {
          return a.archivedAt.localeCompare(b.archivedAt);
        });
        if (event.direction === 'desc') {
          sortedDeletedAt.reverse();
        }
        this.dataSource.data = sortedDeletedAt;
        break;
    }
  }

  onRowClicked(row: any): void {
    this.router.navigate(['/bonus-event', 'form', 'view', row.id]);
  }
}
